import Nullable from '@/types/nullable';
import User from '@/types/user';
import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

interface PrivateRouteProps extends RouteProps {
  component: any;
  user: Nullable<User>;
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { component: Component, user, ...rest } = props;

  const routeRender = (renderProps: any) => {
    if (!user) {
      return <Redirect to={{ pathname: '/auth/login', state: { from: props.location } }} />;
    }

    return <Component user={user} {...renderProps} />;
  };

  return <Route {...rest} render={routeRender} />;
};

export default PrivateRoute;
